import {Component, HostListener} from '@angular/core';
import {MobileAwareComponent} from '../mobile-aware/mobile-aware.component';

@Component({
  selector: 'app-deactivation-aware',
  template: '',
  styles: ['']
})
export abstract class DeactivationAwareComponent extends MobileAwareComponent {

  abstract canDeactivate(): boolean;

  abstract deactivateWarning(): string;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: Event) {
    if (!this.canDeactivate()) {
      $event.returnValue = true;
    }
  }
}
